import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Divider, useTheme, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";

// Reusable info field component
const InfoField = ({ label, value, t }) => (
  <Typography variant="body2" sx={{ mb: 0.5 }}>
    <Box component="span" fontWeight="bold">
      {t(label)}:
    </Box>{" "}
    {value || t("n/a")}
  </Typography>
);

const FarmInfoCard = ({ farm, onClick }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const farmFields = [
    { label: "owner", value: farm.owner_name },
    { label: "area", value: farm.area ? `${farm.area} ${t("acres")}` : null },
    { label: "pin", value: farm.pin_code },
    { label: "recordNumber", value: farm.land_record_number },
  ];

  return (
    <Paper
      elevation={3}
      sx={{
        width: { xs: "100%", sm: 250 },
        p: 2,
        borderRadius: 1,
        borderLeft: `4px solid ${theme.palette.primary.main}`,
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": onClick
          ? {
              transform: "translateY(-4px)",
              boxShadow: 6,
              cursor: "pointer",
            }
          : {},
      }}
      onClick={onClick}
    >
      <Typography
        variant="subtitle1"
        fontWeight="bold"
        sx={{ color: theme.palette.primary.main, mb: 1 }}
      >
        {farm.farm_name}
      </Typography>
      <Divider sx={{ mb: 1.5 }} />

      {farmFields.map((field) => (
        <InfoField
          key={field.label}
          label={field.label}
          value={field.value}
          t={t}
        />
      ))}
    </Paper>
  );
};

FarmInfoCard.propTypes = {
  farm: PropTypes.shape({
    farm_name: PropTypes.string.isRequired,
    owner_name: PropTypes.string.isRequired,
    area: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    pin_code: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    land_record_number: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  }).isRequired,
  onClick: PropTypes.func,
};

export default FarmInfoCard;
